import { type FC } from 'react';
import theme, { th } from 'style/theme';
import curve from 'assets/img/background/curve.svg';
import ParallaxImage from 'components/ParallaxImage';
import { Wrapper } from './styled';

const layers = [curve];

const Curve: FC = () => {
  return (
    <Wrapper>
      <ParallaxImage
        layers={layers}
        parallaxAmount={0}
        bleedColor={th('colors.portGore')({ theme })}
      />
    </Wrapper>
  );
};

export default Curve;
